const styles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  container: provided => ({
    ...provided,
    fontFamily: "'EYInterstate', sans-serif",
    fontSize: '14px',
    color: '#333',
    maxWidth: '300px',
    outline: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    backgroundColor: '#F6F6FA',
    borderRadius: 0,
    height: '52px',
    border: state.isFocused ? '1px solid #C4C4CE' : 'none',
    boxShadow: null,
    '&:hover': {
      borderColor: state.isFocused ? '#C4C4CE' : 'none',
    },
  }),
  placeholder: (provided, state) => {
    let isTopText = state.hasValue || state.selectProps.menuIsOpen || state.selectProps.inputValue;
    if (state.isMulti && !state.selectProps.menuIsOpen) isTopText = false;

    const color = state.isDisabled ? 'rgba(0, 0, 0, 0.38)' : isTopText ? '#747480' : '#2E2E38';
    return {
      ...provided,
      top: isTopText ? 'calc(50% - 8px)' : 'auto',
      left: '8px',
      width: 'calc(100% - 12px)',
      position: 'absolute',
      fontSize: isTopText ? '1rem' : '14px',
      transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
      fontFamily: 'EYInterstate',
      transformOrigin: 'top left',
      color: color,
      transform: isTopText ? 'translate(0, -8px) scale(0.75)' : 'none',
      whiteSpace: isTopText ? 'nowrap' : 'normal',
    };
  },
  input: provided => ({
    ...provided,
    paddingTop: '20px',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    top: state.hasValue || state.selectProps.inputValue ? '65%' : '50%',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? 'rgba(0, 0, 0, 0.38)' : '#333',
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
    '&:hover': {
      color: '#333',
    },
  }),
  indicatorSeparator: () => ({
    width: 0,
  }),
  clearIndicator: () => ({
    display: 'none',
  }),
  menu: provided => ({
    ...provided,
    marginTop: 0,
    borderRadius: 0,
    overflowX: 'hidden',
    border: ' 1px solid #C4C4CE',
    boxShadow: 'none',
    backgroundColor: '#fff',
  }),
  menuList: provided => ({
    ...provided,
    padding: 0,
    backgroundColor: '#fff',
  }),
  multiValue: () => ({
    display: 'none',
  }),
  option: (provided, state) => {
    let backgroundColor;
    if (state.isFocused) {
      backgroundColor = '#F6F6FA';
    } else if (state.isSelected) {
      backgroundColor = 'rgba(0, 126, 255, 0.04)';
    } else {
      backgroundColor = '#fff';
    }

    return {
      ...provided,
      backgroundColor: backgroundColor,
      color: state.isFocused || state.isSelected ? '#333' : '#666666',
      padding: '12px',
      display: 'flex',
      '&:active': {
        backgroundColor: '#F6F6FA',
      },
      '& span.option-detail': {
        display: 'block',
        padding: '2px 0',
        fontSize: '12px',
        color: '#888',
      },
    };
  },
};

export const chipStyles = {
  root: {
    width: '100%',
    '.label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
    },
  },
};

export default styles;
